"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AVPermissionsModal = require("./AVPermissionsModal");
Object.keys(_AVPermissionsModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AVPermissionsModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AVPermissionsModal[key];
    }
  });
});